var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-steps"},_vm._l((_vm.steps),function(step,i){return _c('div',{key:step.name,staticClass:"step",class:{ 'active': step.active },style:({ width: _vm.width() })},[_c('div',{staticClass:"number"},[_vm._v(_vm._s(i + 1))]),_vm._v(" "+_vm._s(step.name)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }